import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { LISTING_STATE_DRAFT } from '../../util/types';
import {
  Button,
  IconSpinner,
  InlineTextButton,
  ListingLink,
  Modal,
  NamedLink,
  UpdatedInvoice,
} from '../../components';
import { EditListingPricingForm } from '../../forms';
import { ensureOwnListing } from '../../util/data';
import { types as sdkTypes } from '../../util/sdkLoader';
import config from '../../config';
import { apiBaseUrl } from '../../util/api';

import css from './EditListingPricingPanel.module.css';
import axios from '../../util/axiosHelper';
import {
  convertMoneyToNumber,
  convertUnitToSubUnit,
  formatMoney,
  unitDivisor,
} from '../../util/currency';
import HelpAndContact from '../HelpAndContact/HelpAndContact';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { createSlug } from '../../util/urlHelpers';
import { compose } from 'redux';

// import { subUnitDivisors } from '../../currency-config';

const { Money } = sdkTypes;

function prepareCurrencyString(amount) {
  if (!amount) return `0:00`;

  const dollar = Math.floor(amount / 100);
  const cents = amount % 100;

  const finalAmount = `${dollar}.${cents.toString().padStart(2, '0')}`;

  return finalAmount;
}

const EditListingPricingPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
    userNativeLang,
    history,
    onManageDisableScrolling,
    params,
    intl,
    currentUser
  } = props;
  const tab = params?.tab;
  // console.log(858, history, onManageDisableScrolling, tab);
  const [fetchInProgress, setFetchInProgress] = useState(true);

  const [priceFromSubCategory, setPriceFromSubCategory] = useState(null);

  const [commissionRate, setCommisissionRate] = useState(null);

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);

  const { price } = currentListing?.attributes;

  const {
    cnesstRule,
    jobCategories,
    workersEarnTip,
    percentageValue,
  } = currentListing?.attributes?.publicData;
  // console.log(currentListing, 987);
  const { publicData } = currentListing?.attributes;
  const { clientPrice } = publicData;
  // console.log(969, clientPrice);
  const clientPriceAsMoney = clientPrice
    ? new Money(clientPrice.amount, clientPrice.currency)
    : null;

  const url = `${apiBaseUrl()}/api/rates/${jobCategories[0].category}/${jobCategories[0].subCategory
    }`;

  const getData = async () => {
    const response = await axios.get(url);
    setPriceFromSubCategory(response.data.basePrice);

    let customCommission = currentUser?.attributes?.profile?.privateData?.commissionRate ?? 0;
    let commission = Math.max(response.data.percentageValue + customCommission, 0);

    setCommisissionRate(commission);

    setFetchInProgress(false);
  };
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [showInvoice, setShowInvoice] = useState(false);

  const updatePrice = async () => {
    // console.log(8);
    await axios
      .post(
        `${apiBaseUrl()}/api/stripe/createOrUpdatePaymentIntent`,
        {
          listingId: currentListing?.id?.uuid,
          // customerId: currentUser?.stripeCustomer?.attributes?.stripeCustomerId,
        },
        { withCredentials: true }
      )
      .then(res => {
        // console.log(963, res);
        setShowInvoiceModal(true);
      })
      .catch(err => console.log(78888, err));
  };

  useEffect(() => {
    getData();
  }, []);
  // console.log(789, fetchInProgress, priceFromSubCategory, commissionRate);

  const basePrice =
    priceFromSubCategory !== null
      ? new Money(
        convertUnitToSubUnit(priceFromSubCategory, unitDivisor(config.currency)) || 0,
        config.currency
      )
      : undefined;

  const clientPriceVal = Math.round(
    priceFromSubCategory + (priceFromSubCategory * commissionRate) / 100
  );

  const clientPriceFetched =
    priceFromSubCategory !== null
      ? new Money(
        convertUnitToSubUnit(clientPriceVal, unitDivisor(config.currency)) || 0,
        config.currency
      )
      : undefined;
  // console.log(
  //   858,
  //   priceFromSubCategory,
  //   priceFromSubCategory + (priceFromSubCategory * commissionRate) / 100,
  //   new Money(
  //     convertUnitToSubUnit(clientPriceVal, unitDivisor(config.currency)) || 0,
  //     config.currency
  //   )
  // );
  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingPricingPanel.title"
      values={{
        listingTitle: (
          <ListingLink listing={listing}>
            <FormattedMessage id="EditListingPricingPanel.listingTitle" />
          </ListingLink>
        ),
      }}
    />
  ) : (
    <>
      <FormattedMessage id="EditListingPricingPanel.pricingTitle" />
    </>
    // <FormattedMessage id="EditListingPricingPanel.createListingTitle" />
  );

  const priceCurrencyValid = price instanceof Money ? price.currency === config.currency : true;
  const form = fetchInProgress ? (
    <IconSpinner />
  ) : priceCurrencyValid ? (
    <>
      <EditListingPricingForm
        className={css.form}
        // initialValues={{ price: new Money(priceFromSubCategory||0, 'USD'), cnesstRule }}
        initialValues={{
          price: price ? price : basePrice,
          cnesstRule,
          clientPrice: publicData?.clientPrice ? clientPriceAsMoney : clientPriceFetched,
          workersEarnTip,
          percentageValue,
          basePrice,
        }}
        onSubmit={async values => {
          // console.log(58, values);
          const { price, cnesstRule, clientPrice, workersEarnTip, percentageValue } = values;
          // console.log(7878, price.amount, (price.amount / unitDivisor(config.currency)).toString());
          const pricingData = {
            price,
            publicData: {
              cnesstRule,
              searchPrice: parseInt(price.amount / unitDivisor(config.currency)),

              clientPrice: clientPrice
                ? {
                  amount: clientPrice?.amount,
                  currency: config.currency,
                }
                : null,
              workersEarnTip,
              percentageValue,
              amountString: prepareCurrencyString(price.amount),
            },
          }


          await onSubmit(pricingData);
          // console.log('second');
          if (currentListing?.attributes?.state === 'published') {
            await axios
              .patch(
                `${apiBaseUrl()}/api/timeStatement/updateListingDetails`,
                {
                  listingId: currentListing?.id?.uuid,
                  providerId: currentListing?.author?.id?.uuid,
                  // customerId: currentUser?.stripeCustomer?.attributes?.stripeCustomerId,
                },
                { withCredentials: true }
              )
              .then(res => { })
              .catch(err => console.log(78888, err));
          }

          if (
            currentListing?.attributes?.state === 'published' &&
            currentListing?.attributes?.price &&
            values?.jobCategories?.[0].category !== publicData?.jobCategories?.[0].category
          ) {
            // console.log(258);
            updatePrice();
          }
        }}
        onChange={onChange}
        saveActionMsg={submitButtonText}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
        commissionRate={commissionRate}
        userNativeLang={userNativeLang}
      />
    </>
  ) : (
    <div className={css.priceCurrencyInvalid}>
      <FormattedMessage id="EditListingPricingPanel.listingPriceCurrencyInvalid" />
    </div>
  );

  return (
    <div className={classes}>
      <HelpAndContact />
      <div className={css.editHeadingDiv}>
        <h1 className={css.title}>{panelTitle}</h1>
        {currentListing?.id?.uuid && isPublished && (
          <div>
            <NamedLink
              name="ListingPage"
              params={{
                id: currentListing?.id?.uuid,
                slug: createSlug(currentListing?.attributes?.title || ''),
              }}
            >
              <FormattedMessage id="EditListing.GoToListing" />
            </NamedLink>
          </div>
        )}
      </div>

      {form}
      <Modal
        id="EditListingContactForm.agreeTermsConditions"
        isOpen={!!showInvoiceModal}
        onClose={() => {
          setShowInvoiceModal(false);
        }}
        onManageDisableScrolling={onManageDisableScrolling}
        usePortal
        containerClassName={css.invoiceModal}
      >
        <>
          <span className={css.invoiceTitle}>
            <FormattedMessage id="UpdatedInvoice.invoiceUpdated" />
          </span>
          {!!showInvoiceModal ? (
            <UpdatedInvoice
              listing={currentListing}
              tab={tab}
              setShowInvoiceModal={setShowInvoiceModal}
            />
          ) : null}
          <div className={css.ButtonContainer}>
            <Button
              type="button"
              className={css.cancelBtn}
              onClick={() => {
                setShowInvoiceModal(false);
              }}
            >
              <FormattedMessage id="UpdatedInvoice.OKAY" />
            </Button>
          </div>
        </>
      </Modal>
    </div>
  );
};

const { func, object, string, bool } = PropTypes;

EditListingPricingPanel.defaultProps = {
  className: null,
  rootClassName: null,
  listing: null,
};

EditListingPricingPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
  currentUser: object
};

export default compose(injectIntl)(EditListingPricingPanel);
